
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/membership/people",
      function () {
        return require("private-next-pages/admin/membership/people/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/membership/people"])
      });
    }
  